import { useEffect } from 'react';

import { Prompt, useLocation } from 'react-router-dom';

export interface U21LeaveWarningProps {
  ignoredRoutes?: (route: string) => boolean;
  message?: string;
  when: boolean;
}

export const U21LeaveWarning = ({
  ignoredRoutes = () => false,
  message = 'Are you sure you want to leave without saving?',
  when,
}: U21LeaveWarningProps) => {
  const { pathname } = useLocation();
  useEffect(() => {
    // eslint-disable-next-line consistent-return
    const onBeforeUnload = (e) => {
      if (when) {
        // eslint-disable-next-line no-param-reassign
        e.returnValue = message;
        return message;
      }
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, [message, when]);

  return (
    <Prompt
      message={({ pathname: nextPathname }) => {
        if (nextPathname === pathname || ignoredRoutes(nextPathname)) {
          return true;
        }
        return message;
      }}
      when={when}
    />
  );
};
